<template>
  <AccountantsSubmenu
    :items="menuItems"
    :route-params="{ customerId: getCompanyId }"
    :class="{ horizontal: horizontal }"
  >
    <template v-slot:titletop>
      <!-- <div class="submenu-title">
        {{ $gettext('Control Panel') }}
      </div> -->
    </template>
  </AccountantsSubmenu>
</template>

<script>
import { mapGetters } from 'vuex'
import AccountantsSubmenu from "@/components/accountants/menus/AccountantsSubmenu.vue";

export default {
  name: 'AccountantsControlPanelMenu',
  components: { AccountantsSubmenu },
  props: {
    horizontal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    }
  },

  computed: {
    ...mapGetters({
      currentCompany: 'main/getCurrentCompany',
      getCompanyId: 'main/getCompanyId',
      controlPanelCustomerCompany: 'accountants/getControlPanelCustomerCompany'
    }),
    currentPage() {
      return this.$route.path
    },
    bsnString() {
      if (this.bsn) return `(BSN ${this.bsn})`

      return ''
    },
    isGekkoAccountant() {
      if (!this.currentCompany.accountant_branding) {
        return false
      }
      return this.currentCompany.accountant_branding.is_gekko_accountant
    },
    menuItems() {
      return [
        {
          key: 'summary',
          label: this.$gettext('Summary'),
          name: 'ControlPanelSummary',
          icon: 'fa-chart-bar',
          analytics: 'control panel summary',
        },
        {
          key: 'costs',
          label: this.$gettext('Costs'),
          name: 'ControlPanelCosts',
          icon: 'fa-shopping-cart',
          analytics: 'control panel costs',
        },
        {
          key: 'invoices',
          label: this.$gettext('Invoices'),
          name: 'ControlPanelInvoices',
          icon: 'fa-file-lines',
          analytics: 'control panel invoices',
        },
        {
          key: 'bank',
          label: 'Bank',
          name: 'ControlPanelBank',
          icon: 'fa-building-columns',
          analytics: 'control panel bank',
        },
        {
          key: 'vat',
          label: this.$gettext('VAT'),
          name: 'ControlPanelVAT',
          icon: 'fa-database',
          analytics: 'control panel vat',
        },
        {
          key: 'foreign-vat',
          label: this.$gettext('Foreign VAT'),
          name: 'ControlPanelForeignVAT',
          icon: 'fa-database',
          analytics: 'control panel foreign vat',
          show: (this.controlPanelCustomerCompany.country === 'NL'),
        },
        {
          key: 'investments',
          label: this.$gettext('Investments'),
          name: 'ControlPanelInvestments',
          icon: 'fa-money-bill-trend-up',
          analytics: 'control panel investments',
        },
        {
          key: 'financial-statements',
          label: this.$gettext('Financial statements'),
          name: 'ControlPanelFinancialStatements',
          icon: 'fa-coins',
          analytics: 'control panel financial-statements',
        },
        {
          key: 'costtypes',
          label: this.$gettext('Cost types'),
          name: 'ControlPanelCostTypes',
          icon: 'fa-credit-card',
          analytics: 'control panel costtypes',
        },
        {
          key: 'tax-return',
          label: this.$gettext('Tax return'),
          name: 'ControlPanelTaxReturn',
          icon: 'fa-balance-scale',
          analytics: 'control panel tax-return',
        },
        {
          key: 'export',
          label: this.$gettext('Export'),
          name: 'ControlPanelExport',
          icon: 'fa-file-export',
          analytics: 'control panel export',
        },
        {
          key: 'files',
          label: this.$gettext('Downloads'),
          name: 'ControlPanelFiles',
          icon: 'fa-download',
          analytics: 'control panel files',
        },
        {
          key: 'bank-connection',
          label: this.$gettext('Bank Connection'),
          name: 'BankConnectionAccountant',
          icon: 'fa-building-columns',
          analytics: 'control panel bank-connection',
          show: this.isGekkoAccountant,
        },
      ];
    },
  },
  methods: {
    activeClass(tabName) {
      if (this.$route.path.includes(tabName)) return 'selected-tab'
      return ''
    },
  },
}
</script>

<style lang="scss">
  .accountants-submenu {
    &.horizontal {
      width: 1366px;
      max-width: 100%;
      margin: 0 auto;
      .accountants-menu--menuitems {
        flex-direction: row;
      }
    }
  }
</style>
